__turbopack_context__.v({
  "className": "geist_8c726197-module__0V8byG__className",
  "variable": "geist_8c726197-module__0V8byG__variable",
});
